import React, { Component } from "react";
import { toast } from "react-toastify";
import vishing from "../../../assets/create_campaign/vishing.png";
import whatsapp from "../../../assets/create_campaign/whatsapp.png";
import smishing from "../../../assets/create_campaign/smishing.png";
import phishing from "../../../assets/create_campaign/emailPhishing.png";
// import cyberScam from "../../../assets/create_campaign/cyberscam.png";
import Attachment from "../../../assets/create_campaign/attachment.png";
import ransomeware from "../../../assets/create_campaign/ransomware.png";
import QRcode from "../../../assets/create_campaign/qrcode.png";
// import removalMedia from "../../../assets/create_campaign/removablemedia.png";
import telegram from "../../../assets/create_campaign/telegram.png";
import { featuresObj } from "../../../globalData";
import { PiSparkleBold } from "react-icons/pi";
import { TRAINING_SUPPORTED_ATTACK_TYPES } from "../simulation-compatibility";
import "./steps.css";

const ALL_ATTACK_VECTORS = [
	{ name: "Phishing", image: phishing },
	{ name: "Ransomware", image: ransomeware },
	{ name: "Smishing", image: smishing },
	{ name: "Vishing", image: vishing },
	{ name: "WhatsApp", image: whatsapp },
	{ name: "Telegram", image: telegram },
	{ name: "Attachment", image: Attachment },
	// { name: "Cyber Scam", image: cyberScam },
	// { name: "Removal Media", image: removalMedia },
	{ name: "QRcode", image: QRcode },
];

export default class AttackVectorStep extends Component {
	handleSelect = (attackType) => {
		if (this.props.onUpdate) {
			this.props.onUpdate({
				attackType: attackType
			});
		}
	}

	validate = () => {
		if (!this.props.attackType) {
			toast.error("Please select an attack vector");
			return false;
		}
		return true;
	}

	render() {
		const { simulationType, attackType, readOnly } = this.props;

		// Filter attack vectors based on simulation type
		let availableAttackVectors = [];
		if (simulationType === "Simulation Attack") {
			availableAttackVectors = ALL_ATTACK_VECTORS;
		} else if (simulationType === "Simulation Attack + Training") {
			availableAttackVectors = ALL_ATTACK_VECTORS.filter(av =>
				TRAINING_SUPPORTED_ATTACK_TYPES.includes(av.name)
			);
		}

		return (
			<div className="step-content-wrapper">
				<div className="step-header">
					<h4>Attack Vector</h4>
					<p>Choose the channel and method used to deliver the simulated attack.</p>
				</div>
				<div className={`attack-vectors-grid ${readOnly ? "read-only" : ""}`}>
					{availableAttackVectors.map((vector) => {
						const isEnabled = featuresObj[vector.name] !== false;
						const isSelected = attackType === vector.name;
						
						return (
							<div
								key={vector.name}
								className={`attack-vector-card ${!isEnabled ? "disabled" : ""} ${isSelected ? "selected" : ""}`}
								onClick={() => !readOnly && isEnabled && this.handleSelect(vector.name)}
								style={
									readOnly
										? isSelected
											? { pointerEvents: "none" }
											: { pointerEvents: "none", opacity: 0.9, filter: "grayscale(100%)" }
										: {}
								}
							>
								{
									(vector.name ==="Vishing" || vector.name === "WhatsApp") && (
										<div className="attack-vector-label-ai"> <PiSparkleBold /> AI</div>
									)
								}
								
								<div className="attack-vector-image">
									<img src={vector.image} alt={vector.name} loading="eager" />
								</div>
								<div className="attack-vector-label">
									{vector.name}
								</div>
							</div>
						);
					})}
				</div>
			</div>
		);
	}
}
